import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NiceSelectModule } from "ng-nice-select";

import { CoreModule } from '@teem/core/core.module';
import { SharedModule } from '@teem/shared/shared.module';

import { PaymentInfoModalComponent } from '@teem/quotes-module/modals/payment-info-modal/payment-info-modal.component';
import { QuotationLinkModalComponent} from '@teem/quotes-module/modals/quotation-link-modal/quotation-link-modal.component';
import { RejectionReasonComponent } from '@teem/quotes-module/modals/rejection-reason/rejection-reason.component';
import { CreateQuotationComponent } from '@teem/quotes-module/create-quotation/create-quotation.component';
import { DeliverableComponent } from '@teem/quotes-module/components/deliverable/deliverable.component';
import { ViewQuotationComponent } from '@teem/quotes-module/view-quotation/view-quotation.component';
import { EditQuotationComponent } from '@teem/quotes-module/edit-quotation/edit-quotation.component';
import { AddItemsComponent } from '@teem/quotes-module/modals/add-items/add-items.component';
import { QuotesRoutingModule } from '@teem/quotes-module/quotes-routing.module';
import { QuotesComponent } from '@teem/quotes-module/quotes.component';

@NgModule({
  declarations: [
    QuotesComponent,
    CreateQuotationComponent,
    EditQuotationComponent,
    DeliverableComponent,
    PaymentInfoModalComponent,
    QuotationLinkModalComponent,
    ViewQuotationComponent,
    AddItemsComponent,
    RejectionReasonComponent
  ],
  entryComponents: [
    PaymentInfoModalComponent
  ],
  imports: [
    NgbModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    QuotesRoutingModule,
    NiceSelectModule,
    SharedModule,
    CoreModule
  ]
})
export class QuotesModule { }
